import React, { useState } from 'react';

const GoogleRolePicker = ({ profile, loading, error, onConfirm, onCancel }) => {
  const [role, setRole] = useState('elderly');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(role);
  };

  return (
    <div className="tamcare-google-role-overlay">
      <div className="tamcare-auth-card tamcare-auth-card--register tamcare-google-role-card">
        <div className="tamcare-auth-card__header tamcare-auth-card__header--center">
          <h2>Chọn vai trò của bạn</h2>
          <p>
            Xin chào{profile?.fullName ? ` ${profile.fullName}` : ''}! Bạn đang đăng nhập lần đầu bằng Google
            {profile?.email ? ` (${profile.email})` : ''}.
          </p>
        </div>

        {error && (
          <div className="tamcare-auth-error" style={{ marginBottom: 16, color: '#ef4444', fontWeight: 600 }}>
            {error}
          </div>
        )}

        <form className="tamcare-auth-form" onSubmit={handleSubmit}>
          <div className="tamcare-role-title">Bạn là ai?</div>
          <div className="tamcare-role-selection">
            <div className="tamcare-role-option">
              <input
                type="radio"
                id="google_role_elderly"
                name="googleRole"
                value="elderly"
                checked={role === 'elderly'}
                onChange={() => setRole('elderly')}
              />
              <label htmlFor="google_role_elderly" className="tamcare-role-label">
                <i className="fa-solid fa-person-cane"></i>
                <span className="tamcare-role-label__title">Người lớn tuổi</span>
                <span className="tamcare-role-label__sub">Chữ to, dễ thao tác</span>
              </label>
            </div>

            <div className="tamcare-role-option">
              <input
                type="radio"
                id="google_role_relative"
                name="googleRole"
                value="relative"
                checked={role === 'relative'}
                onChange={() => setRole('relative')}
              />
              <label htmlFor="google_role_relative" className="tamcare-role-label">
                <i className="fa-solid fa-user-nurse"></i>
                <span className="tamcare-role-label__title">Người Chăm Sóc</span>
                <span className="tamcare-role-label__sub">Quản lý &amp; Theo dõi</span>
              </label>
            </div>
          </div>

          <button type="submit" className="tamcare-auth-btn" disabled={loading}>
            {loading ? 'Đang tạo tài khoản...' : 'Tiếp tục'}
            <i className="fa-solid fa-arrow-right"></i>
          </button>

          <button
            type="button"
            className="tamcare-google-role-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Hủy
          </button>
        </form>
      </div>
    </div>
  );
};

export default GoogleRolePicker;
